import styled from 'styled-components';

const Content = styled.div.attrs(props => ({

}))`
	
`;

export default Content;
